// extracted by mini-css-extract-plugin
export var hero = "about-module--hero--qeezm";
export var bg = "about-module--bg--76g7n";
export var desktop = "about-module--desktop--Lawxv";
export var mobile = "about-module--mobile--mflPm";
export var history = "about-module--history--wf0dn";
export var manifest = "about-module--manifest--b5sVK";
export var practice = "about-module--practice--KGxqE";
export var firstImage = "about-module--firstImage--NAYwD";
export var lastImage = "about-module--lastImage--fB24F";
export var videoContainer = "about-module--videoContainer--PoxTY";
export var videoContent = "about-module--videoContent--BZBs4";
export var bridgeCover = "about-module--bridgeCover--BHnZA";
export var bridgeImage = "about-module--bridgeImage--o3dm7";
export var historyTwo = "about-module--historyTwo--q7fJ7";
export var historyTwoImage = "about-module--historyTwoImage--0UGEJ";
export var info = "about-module--info--pY1as";
export var technologies = "about-module--technologies--fx6zh";
export var slide = "about-module--slide--7tFr0";
export var dots = "about-module--dots--eHUmZ";
export var practiceWrapper = "about-module--practiceWrapper--M4IXs";
export var blog = "about-module--blog--jb-Qz";
export var tab1 = "about-module--tab1--ou59g";
export var tab2 = "about-module--tab2--JjtHA";
export var tab3 = "about-module--tab3--NbFC8";
export var tab4 = "about-module--tab4--x8u4W";
export var practiceContainer = "about-module--practiceContainer--TJ7+p";
export var arrow = "about-module--arrow--Fn6MN";